import { Col, DatePicker, Form, Row } from "antd";
import React, { memo, useCallback } from "react";

const SelectDate = ({ setFieldsValue, type }) => {
  const onChangeStartTime = useCallback(
    (date) => {
      if (type === "TicketFee") {
        setFieldsValue({ from: date });
      } else {
        setFieldsValue({ sign_date_gte: date });
      }
    },
    [setFieldsValue, type]
  );

  const onChangeEndTime = useCallback(
    (date) => {
      if (type === "TicketFee") {
        setFieldsValue({ to: date });
      } else {
        setFieldsValue({ sign_date_lte: date });
      }
    },
    [setFieldsValue, type]
  );

  return (
    <Row justify="space-between">
      <Col span={11}>
        <Form.Item
          label="Bắt đầu từ"
          name={type === "TicketFee" ? "from" : "sign_date_gte"}
        >
          <DatePicker
            onChange={onChangeStartTime}
            style={{ width: "100%" }}
            placeholder="Bắt đầu từ"
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </Col>
      <Col span={11}>
        <Form.Item
          label="Đến"
          name={type === "TicketFee" ? "to" : "sign_date_lte"}
        >
          <DatePicker
            onChange={onChangeEndTime}
            style={{ width: "100%" }}
            placeholder="Đến"
            format="DD/MM/YYYY"
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default memo(SelectDate);
